import { BehaviorParameters } from 'rangeConfig/@types';
import { Entity } from '@inter-ikea-core/core';
import { Product } from '@inter-ikea-storageone/range';

const replaceProduct = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const hasSameSize = (oldEntity: Entity, newProduct: Product) => {
    const oldProductSize = coreApi.entities.getEntityComSize(oldEntity);
    const newProductSize = newProduct?.communicatedDimensions;
    return (
      oldProductSize?.width === newProductSize?.width &&
      oldProductSize?.depth === newProductSize?.depth &&
      oldProductSize?.height === newProductSize?.height
    );
  };

  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return;
  }
  const newProduct = rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId);
  const newProductType = newProduct?.type || '';
  const oldProductType = coreApi.entities.getProductType(selectedEntity) || '';
  if (newProduct && newProductType === oldProductType) {
    const fastReplace = hasSameSize(selectedEntity, newProduct);
    const replacePlacementResult = coreApi.products.replace(
      selectedEntity.id,
      props.coreProductId,
      fastReplace
    );
    if (
      replacePlacementResult?.replacedEntityResult.valid &&
      replacePlacementResult.replacedEntityResult.placedEntity
    ) {
      coreApi.entities.select(replacePlacementResult.replacedEntityResult.placedEntity);
    } else {
      coreApi.history.undo();
      coreApi.history.discardLatestSnapshot();
    }
  } else {
    const replacePlacementResult = coreApi.products.removeAndAdd(
      selectedEntity.id,
      props.coreProductId
    );
    if (replacePlacementResult?.valid && replacePlacementResult.placedEntity) {
      coreApi.entities.select(replacePlacementResult.placedEntity);
    }
  }
};

export default replaceProduct;
